import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ButtonSpecial from '../ButtonSpecial';
import {
  ContTabsTransformationStartsNow,
  SlideArea,
  SlideViewport,
  SlideTrack,
  SlideItem,
  SlideContent,
  ContInfoTransform,
  TitleTransform,
  TextTransform,
  ContPhone,
  CarouselControls,
  ArrowButton,
  DotsList,
  DotButton,
  DesktopCta,
  MobileCta,
} from './TabsTransformationStartsNow.styles';
import ImgTabPanel1 from '../../assets/images/onboardig-digital.webp';
import ImgTabPanel2 from '../../assets/images/plataforma-financiera.webp';
import ImgTabPanel3 from '../../assets/images/automatizacion-de-operaciones.webp';
import ImgTabPanel4 from '../../assets/images/dispersion-y-cobranza.png';

const slidesData = [
  {
    title: 'Onboarding Digital',
    text: 'Permite la verificación de identidad digital de tus clientes mediante biométricos, OCR, voz, en instituciones gubernamentales y las principales listas negras como SAT, OFAC, DEA, etc.',
    mobileText: 'Podrás registrar y verificar la información de nuevos clientes en minutos.',
    alt: 'Onboarding digital Dynamicore',
    image: ImgTabPanel1,
  },
  {
    title: 'Administración de clientes',
    text: 'Administra y genera perfiles de tus clientes en un solo lugar con nuestros módulos de administración de clientes.',
    alt: 'Administración de clientes Dynamicore',
    image: ImgTabPanel2,
  },
  {
    title: 'Automatización de procesos',
    text: 'Deja de realizar largos procesos, hazlo todo de manera digital en cuestión de minutos.',
    alt: 'Automatización de procesos',
    image: ImgTabPanel3,
  },
  {
    title: 'Cobranza y dispersión',
    text: 'Facilitamos la gestión de cobranza y dispersión con procesos confiables y seguros.',
    alt: 'Dispersión y cobranza',
    image: ImgTabPanel4,
  },
];

export const TabsTransformationStartsNow = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const slides = useMemo(() => slidesData, []);
  const total = slides.length;

  const goTo = (nextIndex) => {
    if (nextIndex < 0) {
      setValue(total - 1);
      return;
    }
    if (nextIndex >= total) {
      setValue(0);
      return;
    }
    setValue(nextIndex);
  };

  return (
    <ContTabsTransformationStartsNow>
      <SlideArea>
        <SlideViewport>
          <SlideTrack currentIndex={value}>
            {slides.map((slide) => (
              <SlideItem key={slide.title}>
                <SlideContent container>
                  <SlideContent item xs={12} md={6}>
                    <ContInfoTransform>
                      <TitleTransform>{t(slide.title)}</TitleTransform>
                      <TextTransform>{t(slide.mobileText || slide.text)}</TextTransform>
                      <DesktopCta>
                        <ButtonSpecial
                          text={'Solicita una Demo'}
                          type={'/'}
                          linkTo={'/contacto'}
                          target={'_self'}
                        />
                      </DesktopCta>
                    </ContInfoTransform>
                  </SlideContent>
                  <SlideContent item xs={12} md={6}>
                    <ContPhone>
                      <img src={slide.image} alt={slide.alt} />
                    </ContPhone>
                    <MobileCta>
                      <ButtonSpecial
                        text={'Solicita una Demo'}
                        type={'/'}
                        linkTo={'/contacto'}
                        target={'_self'}
                      />
                    </MobileCta>
                  </SlideContent>
                </SlideContent>
              </SlideItem>
            ))}
          </SlideTrack>
        </SlideViewport>

        <CarouselControls>
          <ArrowButton
            onClick={() => goTo(value - 1)}
            aria-label="Slide anterior"
            type="button"
          >
            <ChevronLeftIcon />
          </ArrowButton>

          <DotsList>
            {slides.map((_, index) => {
              const label = `${index + 1}`.padStart(2, '0');
              return (
                <DotButton
                  key={label}
                  type="button"
                  active={index === value}
                  onClick={() => goTo(index)}
                  aria-label={`Ir al slide ${label}`}
                >
                  {label}
                </DotButton>
              );
            })}
          </DotsList>

          <ArrowButton
            onClick={() => goTo(value + 1)}
            aria-label="Slide siguiente"
            type="button"
          >
            <ChevronRightIcon />
          </ArrowButton>
        </CarouselControls>
      </SlideArea>
    </ContTabsTransformationStartsNow>
  );
};
